export const mainLogoUrlBuilder = (tenant : string) =>
  `/hospital_logos/${tenant}/logo.jpg`;

  // ${process.env.PUBLIC_URL}